<form [formGroup]="categoryForm">
    <fieldset>
        @if (!categoryModel.isEdited) {
            <div class="textContent">
                @for (textLine of displayCategoryTextLines; track textLine) {
                    <div>{{ textLine }}</div>
                }
            </div>
        }
        <pace-core-text-input
            [hidden]="!categoryModel.isEdited"
            [(model)]="displayCategoryText"
            id="categoryInputElement"
            #categoryInputElement
            (valueChange)="onValueChange($event)"
            [parentForm]="categoryFormChildren"
            [ariaLabel]="('INTERNAL_INFO_TEXT_AREA' | translate) + categoryType"
        ></pace-core-text-input>
    </fieldset>
    @if (categoryModel.headerInfo) {
        <p class="headerInfo">
            <strong>{{ lastEditedByLabel }} {{ categoryModel.headerInfo }}</strong>
        </p>
    }
</form>
<div class="modal-footer justify-content-between justify-content-md-end">
    @if (!categoryModel.isEdited) {
        <button
            (click)="sortTextByDate()"
            class="btn btn-primary"
            translate="INTERNAL_INFO_SORT_BY_DATE_BUTTON_LABEL"
            [disabled]="formattedTextLines.length < 2"
            [ngClass]="{ sortText: reverse !== '', reverse: reverse }"
        ></button>
    }
    @if (!categoryModel.isEdited) {
        <button (click)="onEdit()" class="btn btn-primary" translate="INTERNAL_INFO_EDIT_BUTTON_LABEL"></button>
    }
    @if (categoryModel.isEdited) {
        <button (click)="onCancel()" class="btn btn-primary" translate="INTERNAL_INFO_CANCEL_BUTTON_LABEL"></button>
    }
</div>
